import { render } from "./relink.vue?vue&type=template&id=db44e920&lang=pug"
import script from "./relink.vue?vue&type=script&lang=js"
export * from "./relink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__